import { render, staticRenderFns } from "./DanhSachQuyenTheoNguoiDung.vue?vue&type=template&id=15471d70&"
import script from "./DanhSachQuyenTheoNguoiDung.vue?vue&type=script&lang=js&"
export * from "./DanhSachQuyenTheoNguoiDung.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports